import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { Button, Dialog, DialogContent, TextField, DialogTitle } from '@material-ui/core';
import RoleService from '../../../services/RoleService/RoleService';
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../recoil-store/recoil-state';

function UpdateRole({ dialog, setDialog, fetchData }) {
    const { t } = useTranslation();
    const setAlert = useSetRecoilState(alertState);
    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            roleName: dialog.type === 'update' ? dialog.role.role_name : '',
            description: dialog.type === 'update' ? dialog.role.role_description : '',
        }
    });

    const handleClose = () => {
        setDialog(null);
    };

    const onSubmit = async (formData) => {
        let requestType = 'postRole';
        if (dialog.type === 'update') {
            requestType = 'putRole';
            formData = {
                updatingFields: [{
                    'field_name': 'role_name',
                    'field_value': formData.roleName
                }, {
                    'field_name': 'role_description',
                    'field_value': formData.description
                }]
            }
        }
        const response = await RoleService[requestType](formData, dialog.role?.id);
        if (response) {
            setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.ROLE.' + response.message), severity: response.status ? 'success' : 'error' }));
            if (response.status) {
                fetchData();
                setDialog(null);
            }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }));
        }
    };

    return (
        <Dialog open={true} onClose={handleClose}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle id="alert-dialog-title">
                    <div id="about-title">
                        {dialog.type === 'update' ? `${t('CONTENT.ROLE.UPDATE-ROLE')}: ${dialog.role.role_name}`
                            : t('CONTENT.ROLE.ADD-NEW-ROLE')}
                    </div>
                </DialogTitle>
                <DialogContent style={{ width: 480 }} className="dialog-content-area">
                    <p className="modal-text"><span style={{ color: 'red' }}>*</span>{t('CONTENT.ROLE.ROLE-NAME')}</p>
                    <TextField
                        name="roleName"
                        inputRef={register({ required: true })}
                        autoFocus
                        variant="outlined"
                        id="name"
                        type="text"
                        fullWidth
                        size="small"
                    />
                    {errors.roleName && setAlert(alert => ({ ...alert, show: true, message: t('CONTENT.ROLE.NAME-REQUIRED' ), severity: 'error' }))}

                    <p className="modal-text">{t('CONTENT.ROLE.ROLE-DESC')}</p>
                    <TextField
                        name="description"
                        inputRef={register({ required: false })}
                        id="description"
                        type="text"
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={4}
                        size="small"
                        style={{ marginBottom: 20 }}
                    />
                    <Button type="button" onClick={handleClose}
                        style={{ float: 'left', backgroundColor: "#BBBBBB", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
                        {t('CONTENT.USER.CANCEL')}
                    </Button>
                    <Button type="submit"
                        style={{ float: 'right', backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
                        {dialog.type === 'update' ? t('CONTENT.ROLE.UPDATE-ROLE') : t('CONTENT.ROLE.ADD-ROLE')}
                    </Button>
                </DialogContent>
            </form>
        </Dialog>
    );
}

export default UpdateRole;